import React from "react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { Percent } from "lucide-react";

export default function PromoStrip() {
  return (
    <section
      className="relative py-20 lg:py-28 px-6 lg:px-10 border-t border-[color:var(--border)] overflow-hidden"
      data-testid="promo-strip"
    >
      <div className="ambient-glow-blue" style={{ top: "-10%", left: "20%", opacity: 0.35 }} />
      <div className="mx-auto max-w-[1400px] relative">
        <Reveal>
          <div className="text-[11px] uppercase tracking-[0.4em] text-[color:var(--blue)] mb-8">
            Current Offers
          </div>
        </Reveal>
        <div className="grid grid-cols-12 gap-6 lg:gap-10">
          <Reveal delay={0.05} className="col-span-12 lg:col-span-8 lg:col-start-3" testId="promo-financing">
            <div className="p-8 lg:p-12 bg-[color:var(--surface)] border border-[color:var(--border)] rounded-sm h-full flex flex-col justify-between">
              <div>
                <div className="flex items-center gap-4 mb-6">
                  <div className="h-11 w-11 rounded-full border border-[color:var(--blue)] grid place-items-center text-[color:var(--blue)]">
                    <Percent className="h-4 w-4" />
                  </div>
                  <div className="text-[10px] uppercase tracking-[0.35em] text-[color:var(--muted)]">
                    Financing
                  </div>
                </div>
                <h3 className="font-display font-semibold text-[clamp(2rem,3.5vw,3.2rem)] leading-[1.05] text-white">
                  12 months.<br />
                  <span className="font-editorial italic font-normal text-[color:var(--blue)]">Zero interest.</span>
                </h3>
                <p className="mt-6 text-[14.5px] leading-[1.7] text-[color:var(--muted)] font-body max-w-md">
                  Approved buyers can finance any Kinetico system with 12 months of interest-free payments. Terms &amp; conditions apply.
                </p>
              </div>
              <Link to="/contact" className="btn-ghost mt-8 self-start" data-testid="promo-financing-cta">
                Ask about financing
              </Link>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
